
import React from "react";
import { CheckCircle, Gift, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";

interface EarlyAccessSuccessViewProps {
  onClose: () => void;
}

const EarlyAccessSuccessView: React.FC<EarlyAccessSuccessViewProps> = ({ onClose }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4 sm:py-6 space-y-3 sm:space-y-4">
      <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-gradient-to-r from-green-400 to-emerald-500 flex items-center justify-center animate-pulse shadow-lg">
        <CheckCircle className="w-8 h-8 sm:w-12 sm:h-12 text-white" />
      </div>
      
      <div className="text-center space-y-2">
        <h3 className="text-lg sm:text-xl font-black text-white">¡Registro Completado!</h3>
        <p className="text-sm sm:text-base text-propmatch-text-light max-w-sm px-2">
          Eres parte de la elite de inversores Propmatch
        </p>
      </div>
      
      <div className="w-full bg-gradient-to-r from-green-500/20 to-emerald-500/20 border border-green-500/30 rounded-xl p-3 sm:p-4 mt-3 sm:mt-4">
        <div className="flex items-center gap-2 mb-2">
          <Gift className="w-4 h-4 sm:w-5 sm:h-5 text-green-400" />
          <span className="font-bold text-green-400 text-sm sm:text-base">Beneficios Confirmados:</span>
        </div>
        <ul className="space-y-1 text-xs sm:text-sm text-white/90">
          <li className="flex items-center gap-2">
            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 text-green-400 flex-shrink-0" />
            <span>Token de propiedad gratuito ($10 USD)</span>
          </li>
          <li className="flex items-center gap-2">
            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 text-green-400 flex-shrink-0" />
            <span>Acceso prioritario a la plataforma</span>
          </li>
          <li className="flex items-center gap-2">
            <CheckCircle className="w-3 h-3 sm:w-4 sm:h-4 text-green-400 flex-shrink-0" />
            <span>Comisiones reducidas (primeras inversiones)</span>
          </li>
        </ul>
      </div>

      <DialogFooter className="sm:justify-center w-full mt-4">
        <Button
          onClick={onClose}
          variant="gradient"
          size="xl"
          className="w-full transition-all h-12 sm:h-14 text-sm sm:text-base font-bold rounded-lg shadow-lg hover:shadow-xl"
        >
          <CheckCircle className="w-4 h-4 mr-1" />
          <span>Continuar</span>
          <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </DialogFooter>
    </div>
  );
};

export default EarlyAccessSuccessView;
